import React from 'react';
import { motion } from 'framer-motion';
import { BadgeLabel, CtaButton } from '../ui';
import { Lock, Zap, ShieldCheck, Gift } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-grain" data-id="element-145">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-146">
        <img src="https://cdn.magicpatterns.com/uploads/uwdGDeDrMUgBWV2eFo4Fx7/seccion_hero.png" alt="Altar místico bajo la luz de la luna" className="w-full h-full object-cover object-center opacity-40" data-id="element-147" />
        <div className="absolute inset-0 bg-gradient-to-b from-mystic-900/80 via-mystic-900/60 to-mystic-900" data-id="element-148"></div>
        <div className="absolute inset-0 bg-radial-glow opacity-50" data-id="element-149"></div>
      </div>

      {/* Floating Particles (CSS) */}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-150">
        {[...Array(20)].map((_, i) => <div key={i} className="absolute w-1 h-1 bg-gold rounded-full opacity-20 animate-float" style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${5 + Math.random() * 5}s`
      }} data-id="element-151" />)}
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-153">
          <BadgeLabel className="mb-8" data-id="element-154">
            Manual Digital + 2 Bonos Gratis · Solo $12 USD
          </BadgeLabel>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        delay: 0.3,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="relative mb-10 mx-auto" data-id="element-155">
          <div className="absolute inset-0 bg-gold/25 blur-[80px] rounded-full" data-id="element-156"></div>
          <img src="https://cdn.magicpatterns.com/uploads/jsVmmC5EfRnDJ68D5KXFco/seccion_hero.png" alt="Antiguo grimorio del ritual ancestral junto a una vela encendida" className="relative z-10 w-48 md:w-64 lg:w-72 h-auto mx-auto drop-shadow-[0_10px_40px_rgba(0,0,0,0.6)] animate-float" data-id="element-157" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6" data-id="element-158">
          <span className="block" data-id="element-159">"El ritual de 3 noches</span>
          <span className="block text-text-secondary" data-id="element-160">
            que los brujos te ocultan
          </span>
          <span className="block gold-gradient-text" data-id="element-161">
            para que sigas pagándoles"
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-lg md:text-xl text-text-primary max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-162">
          El secreto ancestral que hace que él o ella regrese —
          <br className="hidden md:block" data-id="element-163" />
          usando solo cosas que ya tienes en casa.
          <br data-id="element-164" />
          <span className="text-gold font-bold mt-2 block" data-id="element-165">
            Sin intermediarios. Sin estafas. Sin más esperas.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="w-full" data-id="element-166">
          <CtaButton subtext={<>
                <span className="flex items-center gap-1" data-id="element-168">
                  <Lock size={14} data-id="element-169" /> Pago 100% seguro
                </span>
                <span className="hidden sm:inline" data-id="element-170">·</span>
                <span className="flex items-center gap-1" data-id="element-171">
                  <Zap size={14} data-id="element-172" /> Descarga instantánea
                </span>
                <span className="hidden sm:inline" data-id="element-173">·</span>
                <span className="flex items-center gap-1" data-id="element-174">
                  <ShieldCheck size={14} data-id="element-175" /> Garantía de 7 días sin preguntas
                </span>
              </>} data-id="element-167">
            → QUIERO RECUPERAR A MI AMOR POR $12 USD
          </CtaButton>

          {/* Bonus highlight strip */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 1
        }} className="mt-6 inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-gold/10 border border-gold/40 text-gold backdrop-blur-sm" data-id="element-176">
            <Gift size={18} data-id="element-177" />
            <span className="font-bold text-sm md:text-base" data-id="element-178">
              Hoy incluye 2 bonos gratis
            </span>
            <span className="hidden sm:inline text-text-secondary text-sm" data-id="element-179">
              · Valor adicional de $114 USD
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};